import * as ROUTES from './routes-plcp'

export const navMenu = [
  {
    id: 'home',
    key: ROUTES.HOME,
    title: 'Home'
  },
  {
    id: 'pl-primary-stars',
    key: ROUTES.PLPRIMARYSTARS,
    title: 'PL Primary Stars'
  },
  {
    id: 'pl-kicks',
    key: ROUTES.PLKICKS,
    title: 'PL Kicks'
  },
  {
    id: 'pl-inspires',
    key: ROUTES.PLINSPIRES,
    title: 'PL Inspires'
  },
  {
    id: 'pl-pfa',
    key: ROUTES.PLPFA,
    title: 'PL PFA'
  },
  {
    id: 'facilities',
    key: ROUTES.FACILITIES,
    title: 'Facilities'
  },
  {
    id: 'funding',
    key: ROUTES.FUNDING,
    title: 'Funding'
  },
  {
    id: 'economic-impact',
    key: ROUTES.ECONOMIC_IMPACT,
    title: 'Economic Impact'
  }
  // ,
  // {
  //   id: 'about-the-pl',
  //   key: ROUTES.ABOUTTHEPL,
  //   title: 'About the PL'
  // }
]

export const mpNavMenu = [
  {
    id: 'home',
    key: ROUTES.HOME_MP,
    title: 'Home'
  },
  {
    id: 'pl-primary-stars',
    key: ROUTES.PLPRIMARYSTARS_MP,
    title: 'PL Primary Stars'
  },
  {
    id: 'pl-kicks',
    key: ROUTES.PLKICKS_MP,
    title: 'PL Kicks'
  },
  {
    id: 'pl-inspires',
    key: ROUTES.PLINSPIRES_MP,
    title: 'PL Inspires'
  },
  {
    id: 'pl-pfa',
    key: ROUTES.PLPFA_MP,
    title: 'PL PFA'
  },
  {
    id: 'facilities',
    key: ROUTES.FACILITIES_MP,
    title: 'Facilities'
  },
  {
    id: 'funding',
    key: ROUTES.FUNDING_MP,
    title: 'Funding'
  },
  {
    id: 'economic-impact',
    key: ROUTES.ECONOMIC_IMPACT_MP,
    title: 'Economic Impact'
  }
  // ,
  // {
  //   id: 'about-the-pl',
  //   key: ROUTES.ABOUTTHEPL,
  //   title: 'About the PL'
  // }
]

